import * as helios from "@hyperionbt/helios";
import cx from "clsx";
import { excludeNullishElements } from "common-utils/utils/array";
import { Collection } from "kreate-common/modules/business-types";
import { DisplayableError } from "kreate-common/modules/displayable-error";
import ButtonPrimary from "kreate-common/modules/kreate-ui/components/ButtonPrimary";
import ModalV2 from "kreate-common/modules/kreate-ui/components/ModalV2";
import { buildPartialTx$CreateOffer } from "kreate-protocol/offchain/tx/createOffer";
import { httpGet$GetArtwork } from "kreate-server/commands/GetArtwork/fetcher";
import { httpGet$GetGachaMintingStatus } from "kreate-server/commands/GetGachaMintingStatus/fetcher";
import { httpGet$GetTxStatus } from "kreate-server/commands/GetTxStatus/fetcher";
import React from "react";
import { MdGavel } from "react-icons/md";

import { useProtocolParamsUTxO } from "../../../../../PageArtwork/containers/ArtworkDetailsViewer/containers/SectionEnableMinting/hooks/useProtocolParamsUTxO";
import ModalSuccessGachaMinting from "../../modals/ModalSuccessGachaMinting";
import { getMintingLimit } from "../../utils";
import FigureWaiting from "../FigureWaiting";
import FigureWaiting$PixelWorms from "../FigureWaiting$PixelWorms";
import FigureWaiting$Square from "../FigureWaiting$Square";
import FigureWaiting$TxBreakdown from "../FigureWaiting$TxBreakdown";

import styles from "./index.module.scss";

import { getAddressFromCip30Wallet } from "@/modules/cardano-wallet/utils";
import { useBusyCount } from "@/modules/common-hooks/useBusyCount";
import { assert } from "@/modules/common-utils/assert";
import { waitUntil } from "@/modules/common-utils/async";
import { shamelesslyRevalidateEverything } from "@/modules/common-utils/shamelesslyRevalidateEverything";
import {
  useModalTrigger$ModalAsyncGenerator,
  waitModal,
} from "@/modules/kreate-modals/modals/ModalAsyncGenerator/hooks";
import { useModalTrigger$ModalConnectWallet } from "@/modules/kreate-modals/modals/ModalConnectWallet/hooks/useModalTrigger$ModalConnectWallet";
import { useModalTrigger$ModalFailure } from "@/modules/kreate-modals/modals/ModalFailure/hooks";
import ModalProgress from "@/modules/kreate-modals/modals/ModalProgress";
import { useModalTrigger$ModalProgress } from "@/modules/kreate-modals/modals/ModalProgress/hooks/useModalTrigger$ModalProgress";
import ModalTransactionBreakdown from "@/modules/kreate-modals/modals/ModalTransactionBreakdown";
import { useModalTrigger$ModalTransactionBreakdown } from "@/modules/kreate-modals/modals/ModalTransactionBreakdown/hooks";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collection: Collection;
  disabled?: boolean;
};

const ODDFAM_DISCOUNTED_STAKE_KEYS = [
  "stake1uxqh9rn76n8nynsnyvf4ulndjv0srcc8jtvumut3989cqmgjt49h6",
  "stake1u84fdxnjk0zwrhr2p6wpz02u8t6pxatmvtx5cjxzqafmveczcylds",
  "stake1u929r47dq2njq3zyuhq5j0qd46wdvxrmw95ue4lcjk795pcpq53tf",
  "stake1u8hyjgs0jyv4a7x0shgefk0guhxaxufh8cm7k8n6wqjxczsrg230l",
  "stake1uxztgfgad7wag4wu5qwam0x0yuasflflleakure30cr4x3qpsup35",
  "stake1u86ntkd8emfgj5x32xks5vr5jwqs2sd80qfdly92scrc32getdyl4",
  "stake1uxsrz3skts5cf478ddvw258kc8mg68gzggfyh0qzl43f8ecwwcqcs",
  "stake17ykfvl6t62y5fvryvtsnch3lt406dcpls4n4d9pcekpnumg6v83tq",
  "stake1u9ncrywddh0578qy6rk5qkslzcnxcmxragkd46k742gk7tcgrne55",
  "stake1u8n8mpje20ec8u9z6ely48k5808lu60zcupc6ejskxrv6hskuwen3",
  "stake1uy3ksyszz89qwhwyhx3h5jvw0d3mynqueppgcttc4x6mgdqqwrzps",
  "stake1uxr3559gckxwjzvpfar2c0e2fxc6agtw3veucxnh7v4stdsp35egp",
  "stake1u8vs6t6t0zq7hwav77vcgrsul778cpp35y3wm44n6k9fldglhq2c9",
  "stake1ux4ztnpv893akk980dhdnx2m8gdun860zvwjz4kjdnq5mecfjhzyz",
  "stake1uyg8gsrak5vhv8w0njrq55ygrcq7g3jekpkft9pvq8jm5eguez08h",
  "stake1u8mcz9kxapehm06cxm2z524dwfu00ykh7u7g4lh4g32k3dcf3glwe",
  "stake1u8e06f7mwsaxqel2p5rg57rf3z3w6ja0y7x55k7g4uuf2wsgdqvql",
  "stake1uym3dqawlrrg7m05cggt0mqmgkvslxf4m0v86hwz6q6sf2cwgd07z",
  "stake1ux4y20pc7fvukf73r7kdlzwhdvmy2cdsxsl2crzwy6qymccwqjnm8",
  "stake1uyp45gawcmsexf65krgqp950p0hpzgenpqyyf8m32tma99syznfph",
  "stake1uyfcm9ps0dqpkadzwzh2gxvn574vnlzhmwt84xt8ax67vgq04njze",
  "stake1uy2ef536rz3jkpufhmphxyzzp0h0n6dcemgjg66gx87enjgmueq4w",
  "stake1uxhzzy9h63sx8cv0vj2v0tjjv2v63k8ayw8w3yhaqw9hveqnt2mfe",
  "stake1uyg4w0ufyxddtq7eu3wdn0gyck574dkeqgg5glmy2ettzwcjrcqu0",
  "stake1u97wwps93pvr7hxfwv770vplxfxkeugughtp3h59vhnhxss99e09v",
  "stake1uxwt792vez2zd0lctdkafntf33w47a47lv83e60m8kp0yygcth5xt",
  "stake1ux8j7dwj6jhc77hu72g6hyvr23eeteqxmf2ugx60n07qhpqu3krz7",
  "stake1uxaqgrxgvl0470mnxt7fu5ez63fuj6tz74ucuk09rdgps3grcsz3t",
  "stake1u9z3ydrtsrfwcrmuht2ngl2hhwxk06tm0ha79c82rl66uzs9ycq7n",
  "stake1u9aq9v369jwdat9mcy4nnp3nzrl9npxx5ckekc52pxy2phca0g63k",
  "stake1uyglhqynvvekxhe8kyusls9g30expp4xp5u40kavgjgvz5c6j8u89",
  "stake1ux2etw237cxtghaatyq82azhyskmazyu7a7zcsxaenhqg3swdtztu",
  "stake1uyzcfj0uhh5nl5yquzs6m6a8rnf04ulqsmgd2e393q66dfs8ac075",
  "stake1u9z740r5yndwqnr8hd7sm8aqy58fv573vkq2zjqzhmyhm3qtwxm5j",
  "stake1uyfsul4kqrv2plcd3cy556cmygm3j0mjma54yaefnstxnns5v7cy8",
  "stake1u9gc7escx955j8reyk0t5v5rzx9wem3agsf3uekzmj5khlq54tgtx",
  "stake1u8a7ydnxd26mfgu94fklrd556yy868n6t9rz4mzuskfc89gglrfar",
  "stake1u93g7qstv7nvx9uwzd2ykxcjum4f0awgl9jx542f4ufdv5qnvx3jv",
  "stake1u952gxhxytdyryymut9pdp3pdjuykzn2dnqgfqlrynse9pcx0ygxz",
  "stake1u95v9pavrlhdkqaen6pt06adl6e0zcc2gxnsakxfgjjfhagh8xxjh",
  "stake1uysz2tckzhl3skc67ygtzwkz2gkgun0vlg8t465lfqsr7fgyvrm6w",
  "stake1u8wtljux2wfr77zyvqe4uqhytyzn0d7rstn5hus6rawerjgg9szpz",
  "stake1u8zg4z4w5pjj95m5egrqpg7f3agg9hte2pesysfl3yjqn9gz085th",
  "stake1uxgq60dlrfm7em7zak9zg40g390v7jhf8jatdq3m6fm5fjq784mch",
  "stake1uykme8c7d2lmvxllcqlz7rf0f38v08l0gypuzsv9g0dzdqqetnl05",
  "stake1u986q22mn4qwx8ugmkuzv9kqwyqhnxl0a6c836ed4nrqhpq0se38t",
  "stake1u9hvavaftmjz0c39a4j7lkmkhal2dv5hgyk9un4sllkutds7wm5ry",
  "stake1u93zds0ydx3s9fa8jnapem6kzxzuq9d3tz75qh5vz4ewcts73dxuu",
  "stake1u9d5f6fxwcp4alm0z2pnaegjg9qle6lytscdav4ch48gcds7kgdyl",
  "stake1uy9dtgvgv0mw50g4t8627lvnts2ker30et45rqyxppxzrfc3x9tz3",
  "stake1u86g2l7tdy9jxzjxfpk823fu325u3p4nw9ja4h2kuwmxmpcasunu2",
  "stake1u9q2hh6hu2ky9w3w0r9274zned82dp9fsz2cvv07wf0k8ast8n5y3",
  "stake1uy3f0aw5upz0ymz7ft7kzrxkugs9nrqxk04t5q2zq5ytqacx05cwv",
  "stake1uyj56d7wy2mdm8pg8davhdvgkev3lcpjfzcqc33u56kh7nqwnc95n",
  "stake1u8mv9n9dssvy20jkjafc5cvsdqshkpauzwfrmm2d5pxzv0gm5wjg7",
  "stake1ux5lt7e9pnwnq48nc78qkr847hgf5e5cr2c0dxgdh62d4eqw7nagp",
  "stake1uyy3etygz8gulnlae92jpafl95890hxghuw3mve0vd49qns29a5pt",
  "stake1u935usptka7yverz5erm7k2jhdhrcdf0skhexcdlle9swmcgdzyfm",
  "stake1u8pnkdllfd9a4d78x5x3ze98hj3482argz7gnjs7apjmmwg2zq2ha",
  "stake1uxtn28p52ae6vma7jd9n7q0yf574xpuv2454p3qmg5ke7lq8tqjfw",
  "stake1uxy3pjm9pt73h4k08lq5szy8hljayydqwuxs607hplywdwgwrzlgt",
  "stake1u9ur2gza5upm54xmrtraz5zq0n87xs09gl5pd3s0evkhyxs5un7le",
  "stake1uxav4gxsup2kvl5d3swygxk7x5p6myv9xaunuvz7jdz863czrpldv",
  "stake1uywtuflkjvvj3ny8jlhzup2wz8yjr3kd8tap8ehjfqxl28c2nyz0r",
  "stake1uy43q7zq3h63alqvsj5nmnd00wvn9x3950l9yqq5acpe5ecle0xdk",
  "stake1uyugyg39up99rcky4e6tafk2ch5gqdypsp8mqtnqkq6yzhgz6f4rv",
  "stake1u9s2h8p0rgjgqyxghv4x53zc974fskkxshazjlfuq07wwagfg9j6q",
  "stake1u9kp0aayx24ce8gwz6hu08t4gyasapnadsz6pt3e0u7a2jq4etjxs",
  "stake1u9ads63vhwac6ufsa5jjt5wdme74rqev0wd5ahngyk9gc2czmpd6z",
  "stake1uxn2mpwjgv9excx8q3jrr2gx5m0y7daawq4l7c0gv80ww4csf702w",
  // Kreate for testing
  "stake1u80vkr797l54fkrjldduxzr35x5cgfxxj777u6hzcuqjnhs76wf5a",
];

export default function ButtonGachaMinting({
  className,
  style,
  collection,
  disabled,
}: Props) {
  const { busy, withCustomErrorHandler } = useBusyCount();

  const [protocolParamsUTxO] = useProtocolParamsUTxO();

  const modalTriggers = {
    ModalAsyncGenerator: useModalTrigger$ModalAsyncGenerator(),
    ModalConnectWallet: useModalTrigger$ModalConnectWallet(),
    ModalFailure: useModalTrigger$ModalFailure(),
    ModalProgress: useModalTrigger$ModalProgress(),
    ModalTransactionBreakdown: useModalTrigger$ModalTransactionBreakdown(),
  };

  const handleError = async (error: unknown) => {
    await modalTriggers.ModalFailure.openModalWithError(error);
  };

  const is300Downgrades =
    collection.collectionId === "64db2ca3ad15b21876f93f0d";

  const isPixelWorms = collection.collectionId === "65733b946b5c7ea2bfd113be";

  const handleClick = !protocolParamsUTxO
    ? undefined
    : withCustomErrorHandler(handleError)(async () => {
        const cip30Wallet =
          await modalTriggers.ModalConnectWallet.getCip30WalletOrOpenModal();

        await modalTriggers.ModalAsyncGenerator.openModal(async function* () {
          assert(collection.policyId, "policyId is required");
          assert(
            collection.gachaMinting?.editionPrice != null,
            "not eligible for gacha minting"
          );

          yield (
            <ModalV2.Root open>
              <ModalProgress.Content
                progress={{
                  text: "Building transaction...",
                  ratio: 0.0,
                  ratioUpTo: 0.1,
                  shrinkRatio: 0.9375,
                }}
                customImage={
                  isPixelWorms ? (
                    <FigureWaiting$PixelWorms />
                  ) : !is300Downgrades ? (
                    <FigureWaiting$Square />
                  ) : (
                    <FigureWaiting />
                  )
                }
              />
            </ModalV2.Root>
          );

          const address = await getAddressFromCip30Wallet(cip30Wallet);

          const gachaMintedStatus = await httpGet$GetGachaMintingStatus(
            "/api/v1/gacha/minting-status",
            {
              walletAddress: address,
              policyId: collection.policyId,
            }
          );

          const mintingLimit = getMintingLimit(collection);
          if (
            mintingLimit != null &&
            gachaMintedStatus.noMintedByYourWallet >= mintingLimit
          ) {
            throw new DisplayableError({
              title: "Limit reached",
              description: `You can only mint up to ${mintingLimit} Editions per wallet.`,
              cause: {
                mintingLimit,
                numMinted: gachaMintedStatus.noMintedByYourWallet,
              },
            });
          }

          if (protocolParamsUTxO.datum.type !== "protocol-params") {
            throw new DisplayableError({ title: "Invalid protocol params" });
          }

          let editionPrice = collection.gachaMinting.editionPrice;
          // OddFam discount
          let stakeKey = helios.StakeAddress.fromAddress(
            (await cip30Wallet.usedAddresses)[0]
          ).toBech32();
          if (
            collection.collectionId === "660db3c592ebba468c516900" &&
            ODDFAM_DISCOUNTED_STAKE_KEYS.includes(stakeKey)
          ) {
            editionPrice *= 0.8;
          }

          const { tx, artworkFee, protocolFee, txFee } =
            await buildPartialTx$CreateOffer({
              treasuryAddress: new helios.Address(
                protocolParamsUTxO.datum.value.treasuryAddress
              ),
              wallet: cip30Wallet,
              datumOffer: {
                offererAddress: address,
                assetId: collection.policyId,
                editionPrice,
                wantedQuantity: 1,
                isSecondary: false,
                artistAddress: null,
                editionRoyalty: 0,
              },
              txMessage: undefined,
            }).then((data) => {
              // NOTE: @kien-kreate: adhoc logic, in case of free gacha minting,
              // we only show Platform Fee = protocolFee + artwork fee,
              // and hide Artwork Fee
              const newData = { ...data };
              if (!collection.gachaMinting?.editionPrice) {
                newData.protocolFee += data.artworkFee;
                newData.artworkFee = 0;
              }
              return newData;
            });

          yield* waitModal((resolve, reject) => (
            <ModalTransactionBreakdown
              open
              rows={excludeNullishElements([
                artworkFee
                  ? {
                      label: "Artwork Price",
                      lovelaceAmount: artworkFee,
                      tooltip: "The amount the Artist earns from the mint",
                    }
                  : undefined,
                {
                  label: "Platform Fee",
                  lovelaceAmount: protocolFee,
                  tooltip:
                    "Our platform receives ≈2.22 ₳; ≈0.55 ₳ covers the delivery transaction; the remainder ≈1.23 ₳ is bound to the Artwork and will be returned to you.",
                },
                {
                  label: "Transaction Fee",
                  lovelaceAmount: txFee,
                  tooltip:
                    "The blockchain network fees to process this transaction",
                },
              ])}
              customImage={
                isPixelWorms ? (
                  <FigureWaiting$PixelWorms size="140px" />
                ) : !is300Downgrades ? (
                  <FigureWaiting$TxBreakdown />
                ) : (
                  <FigureWaiting size="140px" />
                )
              }
              description="A randomly chosen Artwork from the Collection will be sent to you! This should take only a few minutes."
              onAccept={() => resolve()}
              onReject={() => reject(null)}
            />
          ));

          yield (
            <ModalV2.Root open>
              <ModalProgress.Content
                progress={{
                  text: "Waiting for signature and submission...",
                  ratio: 0.1,
                  ratioUpTo: 0.2,
                  shrinkRatio: 0.9375,
                }}
                customImage={
                  isPixelWorms ? (
                    <FigureWaiting$PixelWorms />
                  ) : !is300Downgrades ? (
                    <FigureWaiting$Square />
                  ) : (
                    <FigureWaiting />
                  )
                }
              />
            </ModalV2.Root>
          );

          const signatures = await cip30Wallet.signTx(tx);
          tx.addSignatures(signatures);

          const txId = await cip30Wallet.submitTx(tx).then((h) => h.hex);

          yield (
            <ModalV2.Root open>
              <ModalProgress.Content
                progress={{
                  text: "Waiting for confirmation...",
                  ratio: 0.2,
                  ratioUpTo: 0.6,
                  shrinkRatio: 0.96875,
                }}
                customImage={
                  isPixelWorms ? (
                    <FigureWaiting$PixelWorms />
                  ) : !is300Downgrades ? (
                    <FigureWaiting$Square />
                  ) : (
                    <FigureWaiting />
                  )
                }
              />
            </ModalV2.Root>
          );

          await waitUntil(async () => {
            const status = await httpGet$GetTxStatus(
              `/api/v1/tx-status/${txId}`
            );
            return status.ok;
          });

          yield (
            <ModalV2.Root open>
              <ModalProgress.Content
                progress={{
                  text: "🎁 Wrapping up your Artwork!",
                  ratio: 0.6,
                  ratioUpTo: 1.0,
                  shrinkRatio: 0.96875,
                }}
                customImage={
                  isPixelWorms ? (
                    <FigureWaiting$PixelWorms />
                  ) : !is300Downgrades ? (
                    <FigureWaiting$Square />
                  ) : (
                    <FigureWaiting />
                  )
                }
              />
            </ModalV2.Root>
          );

          const gachaMintingStatus = await waitUntil(async () => {
            const status = await httpGet$GetTxStatus(
              `/api/v1/tx-status/${txId}`
            );
            return status.gachaMinting;
          });

          if (gachaMintingStatus.type === "refunded") {
            throw new DisplayableError({
              title: "Transaction Refunded",
              description:
                "Sorry, we couldn’t process your request. Your transaction has been refunded.",
              cause: gachaMintingStatus,
            });
          }

          assert(gachaMintingStatus.type === "fulfilled", "invalid type");
          assert(gachaMintingStatus.artworkIds.length, "empty artworkIds");

          const artworks = await Promise.all(
            gachaMintingStatus.artworkIds.map((artworkId) =>
              httpGet$GetArtwork(`/api/v1/artwork/${artworkId}`)
            )
          );

          await shamelesslyRevalidateEverything();

          for (const artwork of artworks) {
            yield* waitModal((resolve) => (
              <ModalSuccessGachaMinting
                open
                onClose={resolve}
                artwork={artwork}
              />
            ));
          }
        });
      });

  return (
    <div className={cx(styles.container, className)} style={style}>
      <ButtonPrimary
        className={disabled ? styles.disabled : undefined}
        size="xl"
        icon={<MdGavel />}
        onClick={handleClick}
        disabled={busy || disabled}
        smart={false}
        content={
          collection.gachaMinting?.editionPrice === 0
            ? "Free Gacha Mint"
            : "Gacha Mint"
        }
      />
    </div>
  );
}
